export const SERVICES = [
    { value: 'Invoice', label: 'Invoice' },
    { value: 'Expense', label: 'Expense' },
    { value: 'Customer', label: 'Customer' },
    { value: 'Settings', label: 'Settings' },
    { value: 'SideBar', label: 'SideBar' },
   
  ];